import LoadingSpiner from '@/_elements/LoadingSpiner';
import { useMemo } from 'react';
import { FaUsers } from 'react-icons/fa';
import { connect } from 'react-redux';
import { css } from 'twin.macro';

const ChannelDetail = ({ channel: room, currUser, channelId }) => {
    const channel = useMemo(() => {
        const _room = room || (currUser?.roomList || []).find((item) => item?.room?.id === channelId) || {};
        return _room?.room || room;
    }, [room, currUser]);
    return (
        <div>
            {channel ? (
                <div
                    css={css`
                        margin: 0.5rem 0;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                    `}
                >
                    <h1
                        css={css`
                            color: #757575;
                        `}
                    >
                        <b>Channel: {channel.title}</b>
                    </h1>
                    <div>
                        <FaUsers className="icon mr-4" />
                        <b>{channel?.teamData?.name}</b>
                    </div>
                </div>
            ) : (
                <LoadingSpiner size={25} />
            )}
        </div>
    );
};
const mapStateToProps = (state) => ({
    currUser: (state.user || {}).user,
});

export default connect(mapStateToProps, {})(ChannelDetail);
